import React, { useState, useEffect, useContext } from 'react';
import { fetchItemInspect, withAuthCheck, AuthError } from '../services/api';
import { AuthContext } from '../contexts/AuthContext';
import Typography from "@mui/material/Typography";

// Simple in-memory cache: key – itemCode, value – item data
const itemCache = new Map();

export default function GetItemData({ itemCode, children }) {
    const token = useContext(AuthContext);
    const [data, setData] = useState(itemCache.get(itemCode) || null);
    const [loading, setLoading] = useState(!itemCache.has(itemCode));
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!token || !itemCode) return;

        // If data is already in cache – use it immediately
        if (itemCache.has(itemCode)) {
            setData(itemCache.get(itemCode));
            setLoading(false);
            return;
        }

        setLoading(true);
        withAuthCheck(fetchItemInspect, token, itemCode)
            .then((response) => {
                // Data is expected in response.item
                const itemData = response.item;
                // Save to cache
                itemCache.set(itemCode, itemData);
                setData(itemData);
                setLoading(false);
            })
            .catch((err) => {
                if (err instanceof AuthError) {
                    // WebAuthForm will be shown automatically via AuthProvider
                    return;
                }
                console.error('Server error:', err);
                setError(err);
                setLoading(false);
            });
    }, [token, itemCode]);

    if (loading) {
        return <Typography variant="body2">Loading...</Typography>;
    }

    if (error) {
        return <Typography variant="body2">Error.</Typography>;
    }

    // Use render prop to pass data to child component
    return children(data);
}